// akhila 1/12/2022 3031450488 added Search for workqueue
// akhila 3/12/2022 2692790263 added buttons center
// Sohel 12/05/2022 2692790263 workQueue Added CreatedFor Dropdown
// lalitha 12/07/2022 2692790263 added Created By field
// akhila 12/08/2022 2692790263 changed labels workqueue to Work Queue
// akhila 12/08/2022 2692790263 adding session storage for search items
// kavya9reddy 12/09/2022 2692790263 Added createdDate Field
// Raghuarun 12/20/2022 2692790263 fixed text field and button alignments
// Prakash Gummala 12/20/2022 2692790263 Text Field Alignments for tab and desktop resolution.
// Raghu 12/27/2022 2692790263 text fields and button alignments with responsive.
// Raghu 12/29/2022 2692790263 Removed unwanted classes.
// kavyareddy 01/05/2023 2692790263 Fixed label issues
// Akhila 02/08/2023 2692790263 added last run date field
// Dilip 02/13/2023 2692790263 added created for, created by dropdown values
// Ravi 02/22/2023 2692790263 Added Client Code search Field
// suresh peddavoora 2692790263 Textfield alignment fixes
// suresh peddavoora 03/03/2023 2692790263 Tables and fields alignments
// Rohini 03/14/2023 2692790263 fixed the responsive in tab
// Ravi  04/19/2023 2692790263  modified client code dropDownData data
// Ravi 04/27/2023 2692790263 fixed run popup issue
// Sohel 05/26/2023 2692790263 Added Created Date Validation
// Sohel 05/26/2023 2692790263 Added Last Run Date Validation
// Ravi  06/01/2023 2692790263  Added WorkQueue User and Role field
// Prakash Gummala 01/06/2023 2692790263 Text Field Alignments for tab and desktop resolution.
// Akhila 06/08/2023 2692790263 created date change to date created field and column
// Ravi 06/08/2023 2692790263 rearrange search fields
// Sohel 06/16/2023 2692790263 Added WorkQUeue in Add Task
// Prakash 22/06/2023 2692790263 fixed alignments issues.
// Ravi 07/22/2023 2692790263  removed upper case from code

import React, {useEffect, useState, useContext, useRef} from 'react';
import {Formik} from 'formik';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import * as Yup from 'yup';
import ErrorBoundaryForComponents from '.././../../../util/ErrorBoundaryForComponents';
import {useDispatch, useSelector} from 'react-redux';
import {SuccessSnackbar, ErrorSnackbar} from './../../../../components/CustomSnackBar/index';
import PageLoader from './../../../../components/PageLoader/index';
import {ThemeContext} from './../../../../themes/ThemeProvider';
import WorkQueueSearchTable from './WorkQueueSearchTable';
import {
  ResetMessage as resetMessage,
  ResetRunReportToggle as resetRunReportToggle,
  ResetStatus as resetStatus,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
  getAllReportCreatedForData,
} from '../../../../redux/reducers/ReportMaster';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {getClientCodeDropDownData} from '../../../../redux/reducers/TriggerGroup';
import {
  reportMasterRoleName,
  reportMasterUserName,
} from '../../../../redux/reducers/BRE/AddReportMaster';
import {createForOptions, createdByOptions} from '../../../../util/CreatedByForOptions';

const WorkQueueSearch = ({
  setTabValue,
  setBreCode,
  setReportCode,
  openTemplate,
  setOpenTemplate,
  setCopy,
  copy,
  reportMasterSearch=false,
  setReportSearchCode,
  setReportSearch,
  setReportData,
  workQueue,
  setEditExisting,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const {isLoading} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {
    errorMsg,
    successMsg,
    addReportMasterStatus,
    runReportToggle,
    roleNameData,
    userNameData,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const {createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  const schema = Yup.object().shape({
    // code: Yup.string().matches(regexp, "White space and special character are not allowed"),
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
    lastRunDate: Yup.date().typeError('Invalid date format').nullable(),
  });

  const formikRef = useRef();
  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];
  const SearchSessionWorkQueue = JSON.parse(sessionStorage.getItem('WorkQueue'));
  const initialValues = {
    category: '',
    displayName: '',
    globalField: '',
    description: '',
    tableName: '',
    tableField: '',
    fieldType: '',
    code: '',
    title: '',
    createdBy: '',
    createdFor: '',
    createdDate: null,
    isDraft: reportMasterSearch ? {key: 'N', value: 'Completed'} : '',
    lastRunDate: null,
    clientCode: '',
    role: '',
    user: '',
  };

  const handleSubmit = (data) => {
    setSearchFlag(true);
    setSearchData(data);
    setSubmit(true);
    sessionStorage.setItem('WorkQueue', JSON.stringify(data));
  };
  const handleClose = () => {
    setOpenTemplate(false);
  };
  const [searchFlag, setSearchFlag] = useState(false);
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
    dispatch(reportMasterRoleName());
    dispatch(reportMasterUserName());
  }, []);
  useEffect(() => {
    if (runReportToggle) {
      handleClose();
      // setSearchData({});
      setSubmit(true);
      // formikRef?.current?.resetForm();
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
        dispatch(resetRunReportToggle());
      }, 3000);
    } else {
      if (addReportMasterStatus === 200) {
        handleClose();
        setSearchData({});
        setSubmit(true);
        formikRef?.current?.resetForm();
        setTimeout(() => {
          dispatch(resetMessage());
          dispatch(resetStatus());
        }, 3000);
      }
    }
  }, [addReportMasterStatus]);
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedByDropDownData('report'));
    dispatch(fetchCreatedForDropDownData('report'));
    setEditExisting && setEditExisting('');
  }, []);
  return (
    <div className={reportMasterSearch ? 'col-12' : ''}>
      <h2 className="search-title">Work Queue Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={SearchSessionWorkQueue ? SearchSessionWorkQueue : initialValues}
        validationSchema={schema}
        enableReinitialize
        innerRef={formikRef}
      >
        {(props) => {
          const {
            values,
            handleChange,
            handleSubmit,
            handleReset,
            handleBlur,
            errors,
            touched,
            setFieldValue,
          } = props;

          return (
            <div className="">
              <form autoComplete="off" noValidate onSubmit={handleSubmit} onReset={handleReset}>
                <div className="standard-field-textfields new-standard-textfields">
                  <ErrorBoundaryForComponents>
                    <div className="form-row align-items-center">
                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-2 form-group">
                        <TextField
                          // className={` ${classes.labelName} ${classes.inputLabel}`}
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Work Queue Name`}
                          label="Work Queue Name"
                          name="code"
                          value={values?.code}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.code}
                          error={Boolean(touched.code && errors.code)}
                        />
                        <FormHelperText>
                          {touched.code && errors.code && errors.code}
                        </FormHelperText>
                      </div>
                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-4 form-group">
                        <TextField
                          // className={` ${classes.labelName} ${classes.inputLabel}`}
                          className={` ${classes.labelName}`}
                          margin="dense"
                          variant="outlined"
                          placeholder={`Enter Work Queue Description`}
                          label="Work Queue Description"
                          name="description"
                          value={values.description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div
                        className={`col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group autocomplete-field`}
                      >
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="role"
                          id="role"
                          size="small"
                          value={values.role}
                          options={roleNameData || []}
                          getOptionLabel={(option) => {
                            return option && option.roleName ? option.roleName : '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('role', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Work Queue Role"
                                placeholder="Select Work Queue Role"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div
                        className={`col-sm-6 col-md-4 col-lg-3 col-xl-3 form-group autocomplete-field`}
                      >
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="user"
                          id="user"
                          size="small"
                          value={values.user}
                          options={userNameData || []}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createForOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('user', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Work Queue User"
                                placeholder="Select Work Queue User"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4  col-lg-3 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4  col-lg-3 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>

                      <div className="col-xs-4 col-sm-6 col-md-4 col-lg-3 col-xl-2  form-group">
                        <GuiAutoComplete
                          classes={{
                            popper: classes.popper,
                            option: classes.option,
                          }}
                          name="isDraft"
                          id="isDraft"
                          size="small"
                          options={StatusOptions}
                          required
                          disabled={reportMasterSearch}
                          value={values.isDraft}
                          getOptionLabel={(option) => {
                            return option && option?.value;
                          }}
                          onChange={(e, value) => {
                            handleChange(e);
                            setFieldValue('isDraft', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                // className={` ${classes.labelName} ${classes.selectLabel}`}
                                variant="outlined"
                                margin="dense"
                                // InputLabelProps={{ shrink: true }}
                                label="Status"
                                placeholder="Select Status"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-12 col-lg-4 col-xl-12  form-group">
                        <div className="d-flex align-items-center justify-content-xl-center justify-content-lg-start justify-content-md-center">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn ${classes.buttonRoot}`}
                            onClick={() => {
                              handleReset();
                              setSearchData(initialValues);
                              setSubmit(true);
                              sessionStorage.removeItem('WorkQueue');
                            }}
                          >
                            Reset
                          </Button>
                          <Button
                            variant="outlined"
                            type="submit"
                            className={`search-btn ml-1 ${classes.buttonRoot}`}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </div>
              </form>
              {isLoading && <PageLoader />}
              {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
              {successMsg && <SuccessSnackbar successMsg={successMsg} />}
            </div>
          );
        }}
      </Formik>
      <WorkQueueSearchTable
        setTabValue={setTabValue}
        searchData={searchData}
        // setSelectedRows={setSelectedRows}
        // selectedRows={selectedRows}
        searchFlag={searchFlag}
        setBreCode={setBreCode}
        setSubmit={setSubmit}
        submit={submit}
        setSearchData={setSearchData}
        setCopy={setCopy}
        copy={copy}
        reportMasterSearch={reportMasterSearch}
        setReportSearchCode={setReportSearchCode}
        setReportSearch={setReportSearch}
        setReportData={setReportData}
        workQueue={workQueue}
        setEditExisting={setEditExisting}
      />
      {/* <DialogBox open={open} dialogClose={handleClose} title=" Run a Work Queue" maxWidth="xl"> */}
      {/* <RunaWorkQueueMaster
          reportDialogData={reportDialogData}
          setSubmit={setSubmit}
          dialogClose={handleClose}
        /> */}
      {/* </DialogBox> */}
    </div>
  );
};

export default WorkQueueSearch;
